<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
        <component :is="Component" />
      </keep-alive>
  </router-view>
  <tab-bar></tab-bar>
</template>
<script>
import tabBar from "@/components/TabBar";

export default {
  name: "index",
  components: {
    tabBar,
  },
  setup() {},
};
</script>
